import { render, staticRenderFns } from "./SearchResultCourse.vue?vue&type=template&id=136dfed2&scoped=true"
import script from "./SearchResultCourse.vue?vue&type=script&lang=js"
export * from "./SearchResultCourse.vue?vue&type=script&lang=js"
import style0 from "./SearchResultCourse.vue?vue&type=style&index=0&id=136dfed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dfed2",
  null
  
)

export default component.exports